module.exports = __webpack_public_path__ + "img/no-result-error.e478b744.png";